import React, { PureComponent } from 'react';
class DefsPatterns extends PureComponent {
  render() {
    return (
      <defs>
        <pattern
          id="blueStripes"
          width="4"
          height="4"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <rect
            width="2"
            height="4"
            transform="translate(0,0)"
            fill="#0a7cb9"
          />
        </pattern>
        <pattern
          id="greenStripes"
          width="4"
          height="4"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <rect
            width="2"
            height="4"
            transform="translate(0,0)"
            fill="#04b0a8"
          />
        </pattern>
        <pattern
          id="lightBlueStripes"
          width="4"
          height="4"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <rect
            width="2"
            height="4"
            transform="translate(0,0)"
            fill="#00abe6"
          />
        </pattern>
      </defs>
    );
  }
}

export default DefsPatterns;



// WEBPACK FOOTER //
// ./src/components/bubble-chart/defs-patterns.js